import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { API } from 'src/app/services/Api.service';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ChangeEmail } from '../../profile/store/profile.actions';
import { ReplaceUser } from '../store/user-managment.actions';

@Component({
  selector: 'app-replace-user',
  templateUrl: './replace-user.component.html',
  styleUrls: ['./replace-user.component.scss']
})
export class ReplaceUserComponent implements OnInit {

    userToBeReplaced: any = {};
    showPassword: boolean;
    selectedMember;
    constructor(
        private dialogRef: MatDialogRef<any>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private store: Store<AppState>,
        private api: API,
        private router: Router,
        private ngxPermissionService: NgxPermissionsService,
        private fb: FormBuilder) {
        this.dialogRef.disableClose = true;
        this.userToBeReplaced = data.userToBeReplaced;
        this.showPassword = false;
    }
    

    ngOnInit() {
    }

    // changeEmail() {
    //     if (this.changeUserForm.invalid) {
    //         return false;
    //     }

    //     const payload = {
    //         email: this.changeUserForm.value.email,
    //         password: this.changeUserForm.value.password
    //     }

    //     this.store.dispatch(new ChangeEmail(this.data.registeredCountryCode, this.data.registeredPhone, payload));
    //     this.store.select(state => state.profile.changeEmailRes).subscribe(response => {
    //         if (Object.keys(response).length) {
    //             this.dialogRef.close();
    //         }
    //     })
    // }
    // showPasswordFunction() {
    //     this.showPassword = !this.showPassword;
    // }

    onCloseDialog(): void {
        this.dialogRef.close();
    }

    getMembers(event) { 
      this.selectedMember = event.selectedItems;
    }

    replaceUser() {
        const payload = {
          replaceTo : this.selectedMember[0]._id
        };
        this.store.dispatch( new ReplaceUser(this.userToBeReplaced._id, payload));
        this.dialogRef.close();
      }
}
